module.exports = __webpack_public_path__ + "img/sl.dc25a571.svg";